import { types } from "../action-types";

const initialState = {
  loading: false,
  gigs: [],
  error: false,
};

const fetchAllGigsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_GIGSALL_REQUESTED:
      return {
        ...state,
        loading: true,
      };

    case types.FETCH_GIGSALL_SUCCESS:
      return {
        ...state,
        loading: false,
        gigs: action.payload,
        error: false,
      };
    case types.FETCH_GIGSALL_FAILURE:
      return {
        ...state,
        loading: false,
        gigs: [],
        error: true,
      };
    default:
      return state;
  }
};

export default fetchAllGigsReducer;
